import { Language, ProductToLanguageListMap } from '../shared/Language.model';

type PIType = {
    // NOTE: tightly bound to Server/applicationSettings
    pendingReport: Promise<void>;
    requestUrl: string;
    requestData: string;
    resolvePendingReportPromise: any;
    rejectPendingReportPromise: any;
    appSettings: {
        apiUrl: string; // classic API URL endpoint
        baseApiUrl: string; // APIM base URL that can be used for concatenation
        assessmentSite: string;
        alternateApiUrls: [{ altPath: string; altUrl: string }];
        conductorUrl: string;
        designApiUrl: string;
        foldersApiUrl: string;
        hireApiUrl: string;
        permissionsApiUrl: string;
        userApiUrl: string;
        accountManagementApiUrl: string;
        searchApiUrl: string;
        enableProdMode: boolean;
        environmentName: string;
        featureFlagKey: string;
        // Temporary adds for freemium to send alerts that people want to talk to sales
        freeUpgradeAccountWebhookHost: string;
        freeUpgradeAccountWebhookUrl: string;
        hideChecklist: boolean;
        hqForceBCUrl: string;
        goodJobAdAlignmentScoreThreshold: number;
        launchDarklyEnvironmentKey: string;
        launchDarklyFlushIntervalInMilliSeconds: number;
        loggingOn: boolean;
        logToConsole: boolean;
        logMissingTranslationKeys: boolean;
        logRocketAppId: string;
        logRocketEnabled: boolean;
        loggingServiceAPIUrl: string;
        marketingPageUrl: string;
        networkForceBCUrl: string;
        openInvitationBaseUrl: string;
        orgApiUrl: string;
        pendoOn: boolean;
        pendoApiKey: string;
        surveySiteUrl: string;
        translationsCdn: string;
        translationVersion: string;
        translationModeOn: boolean;
        auth0: {
            clientID: string;
            domain: string;
            apiUrl: string;
            cdnUrl: string;
            isMfaEnabled: boolean;
            maxRedirectRetryCount: number;
            redirectDelayMs: number;
        };
        cogDataMaskedCompanyGuids: string[];
        signalRUrl: string;
        jobBenchmarkAssociatedPersonLimit: number;
        surveyTakerUrl: string;
        enablePendoDropdown: boolean;
        dataCollectionUrl: string;
        dataCollectionHostUrl: string;
        oneSchemaClientId: string;
        oneSchemaTemplates: { [key: string]: string };
        orgUploadProcessingTimeoutMinutes: number;
        remoteAppUrl: string;

        qualifiedHirePaywallInteractionId: string;
        qualifiedInspirePaywallInteractionId: string;
        qualifiedDiagnosePaywallInteractionId: string;
        qualifiedHireInteractionId: string;
        qualifiedDesignInteractionId: string;
        qualifiedInspireInteractionId: string;
        qualifiedDiagnoseInteractionId: string;
        qualifiedDefaultInteractionId: string;
        qualifiedHireGetStartedChecklistInteractionId: string;
        pricingPackagingPendoPopupId: string;
        designAppUrl: string;
        hireAppUrl: string;
        diagnoseAppUrl: string;
        adminAppUrl: string;
        performUrl: string;
        performMarketingPageUrl: string;
        inspireAppUrl: string;
        spaAppUrl: string;
        integrationsApiUrl: string;
        teamsBotClientUrl: string;
        dataImportApiUrl: string;
        companySettingsApiUrl: string;
        groupAnalyticsAppUrl: string;
        sellerExperienceAppUrl: string;
        demoAccountsApiUrl: string;
        baManagementURL: string;
        integrationsAdminApiUrl: string;
        employeeAccessApiUrl: string;
        upgradeApiUrl: string;
    };

    languageLocale: string;

    language: Language;

    requestBody?: any;

    productLanguageMap: ProductToLanguageListMap;

    makeRequest: (url: string, jsonPayload: any) => void;
    setFeature: (featureName: string, active: boolean) => void;
    clearState: () => void;
    applicationState?: 'ready' | 'painted';
};

// Get the magic from the window
// https://i.imgur.com/NMCU1Pr.gif

export const PI: PIType = (window as any).PI;
